import { useEffect, useState } from "react";
import Header from "../../Common/Header";
import YourPet from "../../Components/YourPet";
import Loader from "../../loader";

const YourPetPage = () => {
  return (
    <>
      <YourPet />
    </>
  );
};

export default YourPetPage;
